export default __webpack_public_path__ + "static/media/huobi.597ebe71.svg";